export const PLAY_STORE_IMG = '/login/assets/public/Playstore.png'
export const APP_STORE_IMG = '/login/assets/public/Appstore.png'
export const IOS_HREF = 'https://apps.apple.com/us/app/northwestern-mutual/id1132579006'
export const ANDROID_HREF = 'https://play.google.com/store/apps/details?id=com.nm.nm'
export const QR_CODE = '/login/assets/public/QR_AppLoginDownload.png'
